import { computed, ref } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import { formatterColTransferUnit, roundToTwoDecimals } from '@/utils/format';
import moment from 'moment';

const useCurrentReactive = () => {
    const { fund_holding, fund_holding_chart, fund_holding_page } = useModuleData();
    const { loadModuleConfig, checkDisplayIndex } = useModuleConfig();

    const dateRange = ref([]);
    const activeDate = ref('');

    // 概览数据
    const summaryData = computed(() => fund_holding.data?.data || {});


    const loadSummary = async () => {
        await fund_holding.refresh();
        const { currentYearDate } = summaryData.value;
        actionDate(currentYearDate);
    };

    const actionDate = date => {
        const { year, period } = date;
        if (!year || !period) {
            if (dateRange.value.length) activeDate.value = dateRange.value[0].value;
        } else {
            activeDate.value = `${year} ${period}`;
        }
    };

    // 计算总持股数
    const computedHoldVolumeSum = computed(() => {
        return splitAmount(summaryData.value?.holdVolumeSum);
    });

    const computedRatioSum = computed(() => {
        return roundToTwoDecimals(summaryData.value?.ratioSum);
    })

    // 格式化金额
    const splitAmount = amount => {
        const [value, unit] = formatterColTransferUnit(amount, true);
        return { value, unit };
    };

    const showTotalHoldings = computed(() => checkDisplayIndex(1));
    const showPercentage = computed(() => checkDisplayIndex(2));


    const barChartOrigin = computed(() => fund_holding_chart.data?.data || []);
    const barChartMap = ref(new Map());
    // 图表数据
    const chartData = computed(() => {
        const data = [...(barChartOrigin.value || [])];
        return [
            {
                type: 'bar',
                data: data.map(ele => {
                    barChartMap.value.set(ele.reportDate, ele);
                    return [ele.reportDate, ele.holdVolume];
                })
            }
        ];
    });


    
    const loadBarData = async () => {
        // 获取当前时间作为结束时间
        const endTime = moment().valueOf();
        // 计算两年前的开始时间
        const startTime = moment().subtract(2, 'years').startOf('day').valueOf();

        await fund_holding_chart.refresh({
            startTime,
            endTime
        });
    };

    return {
        activeDate,
        summaryData,
        chartData,
        computedHoldVolumeSum,
        computedRatioSum,
        showTotalHoldings,
        showPercentage,
        fund_holding_page,
        barChartMap,
        loadModuleConfig,
        loadSummary,
        actionDate,
        loadBarData,
        barChartOrigin
    }
}

export { useCurrentReactive }